import { Link } from 'react-router-dom';
import { Controller, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import api from 'lib/trpcClient';
import { VEHICLES } from 'adminConstants/routes';
import ButtonGroup from 'components/ButtonGroup';
import Button from 'components/Button';
import { vehicle as rules } from 'further-ui/validations';
import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';
import TextField from 'components/FormElements/AppTextInput';
import Page from 'components/new/Page';
import FormField from 'further-ui/components/FormField';

type FieldValues = {
  vehicleName: string;
};

const AddVehicle: React.FC = () => {
  const mutationOpts = useHandleTrpcMutation();

  const addVehicle = api.vehicle.create.useMutation(
    mutationOpts({
      successMessage: 'Vehicle created successfully',
      successRedirect: VEHICLES,
    }),
  );

  const { handleSubmit, control } = useForm<FieldValues>({
    shouldFocusError: true,
    resolver: zodResolver(rules.Create),
    criteriaMode: 'all',
  });

  const onSubmit = (data: FieldValues) => {
    addVehicle.mutate({ ...data });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Page
        heading="Add Vehicle"
        goBackAction={VEHICLES}
        spacing="lg"
        actionBar={
          <ButtonGroup align="stretch">
            <Link to={VEHICLES}>
              <Button variant="outlined" size="large">
                Cancel
              </Button>
            </Link>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              loading={addVehicle.isPending}
              size="large"
            >
              Save
            </Button>
          </ButtonGroup>
        }
      >
        <FormField label="Vehicle name" size="md">
          <Controller
            name="vehicleName"
            control={control}
            render={({ fieldState: { error }, field: { ref, ...rest } }) => (
              <TextField
                {...rest}
                inputRef={ref}
                placeholder="e.g. Venture Fund I"
                helperText={error?.message?.toString()}
                fullWidth
              />
            )}
          />
        </FormField>
      </Page>
    </form>
  );
};

export default AddVehicle;
